import * as ActionTypes from './actionTypes';

export const addNewCommercialUser = (id, dealer = '') => {
  return {
    'type': ActionTypes.ADD_NEW_USER_ROW,
    'payload': {
      'newRow': {
        id,
        'concesionario': dealer,
        'agencia': '',
        'departamento': '',
        'usuario': '',
        'nombres': '',
        'apellidos': '',
        'cargo': '',
        'ciudad': '',
        'telefono': '',
        'correo': '',
        'exportado': '',
        'estado': '',
      },
      'id': id,
    },
  };
};

export const updateNewCommercialUser = (id, newData) => {
  return {
    'type': ActionTypes.UPDATE_NEW_USER_DATA,
    'payload': {
      newData,
      id,
    },
  };
};
